import {
  faCalendarWeek,
  faPartyHorn,
  faUnlock,
} from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Button,
  JoonUIColor,
  Modal,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import useRewardsUserSelectStore from "./hooks/useRewardsUserSelectStore"
import { localStorageItems } from "../../util/storage"

interface ScreenTimeRestrictionFTUXModalStore {
  isOpen: boolean
  onOpen: (childId: number) => void
  onClose: () => void
  childId: number | null
}

export const useScreenTimeRestrictionFTUXModalStore =
  create<ScreenTimeRestrictionFTUXModalStore>((set) => ({
    isOpen: false,
    onOpen: (childId) => set({ isOpen: true, childId }),
    onClose: () => {
      localStorage.setItem(
        localStorageItems.hasSeenSTRestrictionFTUXModal,
        "true"
      )
      set({ isOpen: false })
    },
    childId: null,
  }))

const ScreenTimeRestrictionFTUXModal = () => {
  const { isOpen, onClose, childId } = useScreenTimeRestrictionFTUXModalStore()
  const { setSelectedUserId } = useRewardsUserSelectStore()
  const { t } = useTranslation()

  const onCheckItOut = () => {
    onClose()
    if (!childId) return
    setSelectedUserId(childId)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} animate displayCloseIcon>
      <div
        className="flex flex-col gap-4 py-6"
        style={{
          width: "min(450px, 100vw)",
        }}
      >
        <div className="flex flex-col px-6">
          <Typography
            variant="bodyXSmallBold"
            className="px-2 py-1 mb-2 bg-yellow-300 rounded-md w-fit"
          >
            {t("STR_FTUX_NEW_BADGE")}
          </Typography>
          <Typography variant="h3" textAlign="left">
            {t("STR_FTUX_TITLE")}
          </Typography>
        </div>
        <img
          src={"/images/screen_time_restriction_ftux.png"}
          alt="Screen Time Restriction Announcement"
        />
        <div className="flex flex-col gap-4 px-6 items-center">
          <div className="flex flex-row gap-2">
            <div className="flex w-6 justify-center">
              <FontAwesomeIcon
                icon={faUnlock}
                fontSize={18}
                color={JoonUIColor.icon.accent}
              />
            </div>
            <div className="flex flex-col gap-1">
              <Typography variant="bodySmallBold">
                {t("STR_FTUX_FEAT1_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                {t("STR_FTUX_FEAT1_DESC")}
              </Typography>
            </div>
          </div>
          <div className="flex flex-row gap-2">
            <div className="flex w-6 justify-center">
              <FontAwesomeIcon
                icon={faCalendarWeek}
                fontSize={18}
                color={JoonUIColor.icon.accent}
              />
            </div>
            <div className="flex flex-col gap-1">
              <Typography variant="bodySmallBold">
                {t("STR_FTUX_FEAT2_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                {t("STR_FTUX_FEAT2_DESC")}
              </Typography>
            </div>
          </div>
          <div className="flex flex-row gap-2">
            <div className="flex w-6 justify-center">
              <FontAwesomeIcon
                icon={faPartyHorn}
                fontSize={18}
                color={JoonUIColor.icon.accent}
              />
            </div>
            <div className="flex flex-col gap-1">
              <Typography variant="bodySmallBold">
                {t("STR_FTUX_FEAT3_TITLE")}
              </Typography>
              <Typography variant="bodySmall">
                {t("STR_FTUX_FEAT3_DESC")}
              </Typography>
            </div>
          </div>
          <Button
            text={t("STR_FTUX_CHECK_IT_OUT")}
            onClick={onCheckItOut}
            fullWidth
          />
          <TextButton onClick={onClose} style={{ width: "fit-content" }}>
            <Typography
              variant="bodyBold"
              color={JoonUIColor.text.primaryAccent}
            >
              {t("STR_FTUX_MAYBE_LATER")}
            </Typography>
          </TextButton>
        </div>
      </div>
    </Modal>
  )
}

export default ScreenTimeRestrictionFTUXModal
